<template>
  <div>
    <!-- 导航栏 -->
    <div class="head">
      <div class="header">
        <div class="logo">
          <!-- <a href="/"><img src="../assets/images/logoNew.png" alt="" /></a> -->
          <a href="/"><img src="../assets/images/logo.jpg" alt="" /></a>
          <!-- <a href="/shopping"><img src="../assets/images/logo-标准色-透明-公司名.jpg" alt="" /></a> -->
          <!-- <a href="/shopping"><img src="../assets/images/logo-word.jpg" alt="" /></a> -->
        </div>
        <div class="content">
          <div class="list"  v-for="(item, index) in menuslist" :key="index" @click="goMenu(item,index)"
           @mouseover="enter(index)" @mouseleave="leave" >
            <div v-if="item.child_list && item.child_list.length > 0" class="list-top">
              <div class="list-item" :class="{active:activeIndex==index}">
                {{ item.name }}
              </div>
                  <ul class="list-sub" v-show="menu==index" >
                    <li  class="sub-item"  v-for="(subitem, i) in item.child_list" :key="i" @click.stop="goMenuList(subitem,index)">
                      <span :class="{dyColor:dyColor==i}" @mouseover="enterList(i)" @mouseleave="leaveList"> {{ subitem.name }}</span>
                    </li>
                  </ul>
            </div>
            <div  class="list-top box" :class="{active:activeIndex==index}" v-else> {{ item.name }}</div>
          </div>
          <!-- <div style="text-align: center; font-size: 18px;" class="list-item"  :class="{active:activeIndex==7}" key="7" @click="goMenu({'url_index':'/zisonaiApp'},7)">zisonai</div> -->
        </div>
        <div class="href">
          <a href="http://mail.zisonai.com/" target="_blank">邮箱 |</a>
          <a href="http://club.zisonai.com/" target="_blank"> 论坛</a>
          <!-- <div v-if="!user">
              <a @click="$router.push('/login/1')" style="cursor: pointer;">登录 |</a>
              <a @click="$router.push('/login/2')" style="cursor: pointer;">注册</a>
          </div>
          <div v-else>
              <a @click="$router.push('/MyCart')" style="cursor: pointer;"><i class="el-icon-shopping-cart-2" style="font-size: 18px;"></i> |</a>
              <a @click="goBack" style="cursor: pointer;"> 退出</a>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 右侧悬浮小标识 -->
    <div class="float">
      <div class="chart">
        <img src="../assets/images/微信.png" alt="" />
        <div class="ewm"><img :src="wx_img" alt="" /></div>
      </div>
      <div class="wchart">
        <img src="../assets/images/公众号.png" alt="" />
        <div class="ewm"><img :src="gzh_img" alt="" /></div>
      </div>
      <div class="phone">
        <img src="../assets/images/电话.png" alt="" />
        <div class="dh">{{ phone }}</div>
      </div>
      <!-- <div class="cart" @click="goMyCart">
        <el-badge :value="badgeVal" class="item" v-if="badgeVal > 0">
          <img src="../assets/images/购物车.png" alt="" @click="goCart"/>
        </el-badge>
        <el-badge class="item" v-else>
          <img src="../assets/images/购物车.png" alt="" @click="goCart"/>
        </el-badge>
      </div> -->
      <div class="service" @click="close()">
          <div style="color:#fff ; opacity: .7;">
            <img src="../assets/images/info.jpg" alt=""/>
          </div>
      </div>
      <div class="top" v-show="showbtn">
        <el-backtop :visibility-height="120">
          <i class="el-icon-caret-top"></i>
        </el-backtop>
      </div>
    </div>
    <div class="info" v-show="isBox">
      <div class="top"  @click="close()">
        <span class="title">留言板</span>
        <span class="close"></span>
      </div>
      <div class="info-title">北京智胜远景科技有限公司</div>
      <div class="bottom">
        <el-form 
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item prop="content">
          <el-input type="textarea" v-model="form.content" rows="5" placeholder="请在此输入资询内容，我们会尽快与您联系"></el-input>
        </el-form-item>
        <el-form-item>
            <el-input prefix-icon="el-icon-user" v-model="form.name" placeholder="用户名">
            </el-input>
        </el-form-item>
        <el-form-item  prop="phone">
          <el-input prefix-icon="el-icon-phone"  v-model="form.phone" placeholder="电话（必填）">
          </el-input>
        </el-form-item>
        <el-form-item>
        <el-button size="medium" type="primary" @click="onSubmit" class="btn">提交</el-button>
        </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from "../api/index";
import { mapMutations, mapState } from 'vuex';
import url from "../api/baseurl";
export default {
  data() {
    return {
      dyColor:-1,
      activeIndex:0,
      menu:0,
      badgeVal: 0,
      wx_img: "",
      gzh_img: "",
      phone: "",
      isBox: true,
      category2: [],
      category3: [],
      gid: "",
      form: {
        name: "",
        phone: "",
        content: "",
      },
      rules: {
        content: [
          { required: true, message: "请输入您的问题", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
      },
      // menuslist: [],
      showbtn: false,
      // isShow: [false, false, false, false, false, false, false,false],
      path: this.$route.path,
      val:'',
    };
  },
  watch:{
    $route: function (to, from) {
      if (to != from) {
        this.activeIndex=window.localStorage.getItem('activeIndex',this.activeIndex );
      }
    }
  },
  // watch: {
  //   $route: function (to, from) {
  //     //console.log(to,from);
  //     //监听页面跳转 自带下拉一级样式-----------
  //     if (to != from) {
  //       this.isShow[1] = false;
  //       this.isShow[2] = false;
  //       this.isShow[5] = false;
  //       if (this.$route.name == "hardware") {
  //         this.isShow[1] = true;
  //       } else if (this.$route.name == "software") {
  //         this.isShow[2] = true;
  //       } else if (this.$route.name == "about") {
  //         this.isShow[5] = true;
  //       }
  //     }

  //     if (this.$route.name == "newsdetial") {
  //       this.path = "/newslist";
  //     } else if (this.$route.name == "detial") {
  //       this.path = "/solutions";
  //     }else {
  //       this.path = this.$route.path;
  //     }
  //   },
  // },
  created() {
    this.activeIndex=window.localStorage.getItem('activeIndex',this.activeIndex );
    // if (this.$route.path=="/shopping") {
    //   this.activeIndex=0
    // }
    if (this.$route.path=="/") {
      this.activeIndex=0
    }
    // console.log("获取的购物车数据===========",this.badgeVal);
    // 购物车的数据
    this.eventBus.$on("sendData", (val) => {
      this.badgeVal = this.badgeVal+val;
      // console.log("兄弟传过来的值----------------",this.badgeVal);
    });
    this.getCategoryInfo3({ mid: 3 });
    this.getCategoryInfo2({ mid: 2 });
    // for(var i=0;i<this.menuslist.length;i++){
    //   if(this.menuslist[i].children&&this.menuslist[i].children.length > 0){
    //     // //console.log("长度----------------");
    //     for(var j=0;j<this.menuslist[i].children.length;j++){
    //       this.$router.path==this.menuslist[i].path?this.path:this.$router

    //       // this.path = this.menuslist[i].path;
    //     }
    //   }else{
    // if (this.$route.name == "newsdetial") {
    //   this.path = "/newslist";
    // } else if (this.$route.name == "detial") {
    //   this.path = "/solutions";
    // }   else if (this.$route.name == "hardware") {
    //   //console.log("hard---------------");
    //   this.isShow[1] = true;
    // } else if (this.$route.name == "software") {
    //   this.isShow[2] = true;
    // } else if (this.$route.name == "about") {
    //   this.isShow[5] = true;
    // } else {
    //   this.path = this.$route.path;
    // }
    window.addEventListener("scroll", this.handleScroll, true);
    this.getData();
  },
  mounted() {
    setInterval(() => {
      this.isBox = true;
    }, 60000);
    // 获取企业介绍列表
    this.introductionList({ type: 3 });
  },
  computed:{
      ...mapState("login",["user"]),
      ...mapState("header",["menuslist"])
  },
  methods: {
    ...mapMutations("solution", ["setImg", "setName", "setDesc"]),
    ...mapMutations("header", ["setMenuslist"]),
    // 跳转以及路由界面------
    goMenu(item,index){
      this.activeIndex=index
      window.localStorage.setItem('activeIndex',this.activeIndex );
      this.$router.push(item.url_index)
    },
    goMenuList(item,index){
      this.activeIndex=index
      this.menu=-1
      window.localStorage.setItem('activeIndex',this.activeIndex );
      this.$router.push(item.url_index + '/' + item.id)
      this.category2.forEach((ele) => {
        if (ele.id == item.id) {
          this.setImg(ele.banner);
          this.setName(ele.name);
          this.setDesc(ele.desc);
        }
      });
      this.category3.forEach((ele) => {
        if (ele.id == item.id) {
          this.setImg(ele.banner);
          this.setName(ele.name);
          this.setDesc(ele.desc);
        }
      });
    },
    enter(index){
      // console.log("鼠标移入了",index);
      this.menu=index
    },
    leave(){
      this.menu=0
    },
    enterList(i){
      this.dyColor=i

    },
    leaveList(){
      this.dyColor=-1
    },
    ...mapMutations("login",["delUser"]),
    ...mapMutations("cart",["delCartList"]),
    goBack(){
      this.badgeVal=0
      // 退出清空用户信息和购物车信息
      this.$router.push('/')
      this.delUser()
      this.delCartList()
      console.log(this.setUser);
    },
    go(){
      // window.open("/shopping")
      this.$router.push('/shopping')
    },
    // 点击跳转到购物车
    goMyCart(){
      this.$router.push("/MyCart")
    },
    // 获取企业介绍列表
    introductionList(params) {
      this.$api.aboutList(params).then((res) => {
        //console.log('introductionList--------------------',res.data.data.list);
        //   res.data.data.list[0].img=url + res.data.data.list[0].img
        this.wx_img = url + res.data.data.list[0].wx_img;
        this.gzh_img = url + res.data.data.list[0].gzh_img;
        this.phone = res.data.data.list[0].phone;
      });
    },

    onSubmit() {
      this.message({
        content: this.form.content,
        phone: this.form.phone,
        name: this.form.name,
      });
    },
    close() {
      this.isBox = !this.isBox;
    },
    async getCategoryInfo2(params) {
      let res = await this.$api.getCategoryInfo(params);
      //console.log("----------this.list2222222222-----------", res.data.data);
      this.category2 = res.data.data.category_info;
      this.category2.forEach((ele) => {
        ele.banner = baseUrl + ele.banner;
      });
    },
    async getCategoryInfo3(params) {
      let res = await this.$api.getCategoryInfo(params);
      //console.log("----------this.list33333333333333-----------", res.data.data);
      this.category3 = res.data.data.category_info;
      this.category3.forEach((ele) => {
        ele.banner = baseUrl + ele.banner;
      });
    },
    async getData() {
      let res = await this.$api.getData();
      this.setMenuslist( res.data.menu_list)
      // this.menuslist = res.data.menu_list;
      console.log("导航数据-------------------------", this.menuslist);
    },
    async message(params) {
      let res = await this.$api.message(params);
      if (res.data.code == 1) {
        this.$notify({
          message: "您的问题已提交，请耐心等待我们的工作人员联系您",
          position: "bottom-right",
        });
        this.form = {};
      } else {
        this.$notify({
          message: res.data.msg,
          position: "bottom-right",
        });
      }
      //console.log(res);
    },
    handleScroll() {
      var top = Math.floor(
        document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageYOffset
      );
      if (top > 120) {
        // //console.log("111111111111111");
        this.showbtn = true;
        // //console.log(this.showbtn,top)
      } else {
        this.showbtn = false;
      }
    },

    handleSelectMenu(item, e) {
      //console.log("点了--------------");
      if (item == "/hardware") {
        this.$router.push({ name: "hardware" });
      } else if (item == "/about") {
        this.$router.push({ name: "about" });
      } else if (item == "/software") {
        this.$router.push({ name: "software" });
      }
    },

    goCart(){
      this.$router.push('/MyCart')
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1200px) {
  .activeSub{
    display: block;
  }
  .active{
    border-bottom: 2px solid #3f66f5;
    color:#3f66f5 ;
  }
  .dyColor{
    color:#3f66f5 ;
  }

  .list-item{
    padding: 13px 0 10px 0;
     margin: 0 15px; 
     width: 100px;
  }
  .box{
    padding: 13px;
    width: 100px;
  }
  .head{
    height: 85px;
    .header {
    display: flex;
    // align-items: end;
    width: 100%;
    position: fixed;
    top: 0px;
    z-index: 222;
    padding-bottom: 0.25rem;
    background-color: #fff;
    .logo {
      position: relative;
      width: 3.3rem;
      img {
        display: block;
        position: absolute;
        top: 22px;
        right:40px;
        // width: 146px;
        // height: 55px;
      }
    }
    .href {
      width: 3rem;
      // padding-top: 0.3rem;
      padding-left: 0.75rem;
      margin-top: 35px;
      a {
        color: #666;
        font-weight: 520;
      }
      a:hover {
        color: #3f66f5;
      }
    }

    .content{
    flex: 1;
    cursor: pointer;
    display: flex;
    padding-top: 20px;
    color: #666;
    .list{
      flex: 1;
      .list-top{
        position: relative;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        .list-sub{
          position: absolute;
          top: 49px;
          left: 0px;
          background-color: #fff;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          padding: 10px;
          border-radius: 10px;
          text-align: left;
          min-width: 148px;
          .sub-item{
            color: #666;
            height: 36px;
            line-height: 36px;
            font-size: 18px;
          }

        }

      }
    }
  }

  }
  

  }
  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
  .info-title {
    padding: 15px;
    text-align: center;
    font-size: 16px;
    margin-top: 8px;
  }
  .info {
    z-index: 32;
    position: fixed;
    bottom: 45px;
    right: 110px;
    width: 280px;
    min-height: 350px;
    background-color: #fff;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    .top {
      height: 46px;
      line-height: 46px;
      font-size: 14px;
      background-color: #00006d;
      opacity: 0.7;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      .title {
        float: left;
        font-size: 14px;
        color: #fff;
        margin-left: 12px;
        line-height: 46px;
        padding-left: 2px;
      }
      .close {
        margin-top: 20px;
        margin-right: 10px;
        float: right;
        width: 20px;
        height: 3px;
        background-color: #fff;
      }
    }
    .btn {
      float: right;
      background-color: #00006d;
      opacity: 0.7;
    }
    .bottom {
      padding: 10px;
    }
  }
  .about {
    width: 100%;
    color: #3f66f5;
    height: 48.3px !important;
    border-bottom: 2px solid #3f66f5;
    text-align: center;
  }
  /deep/.content > ul > li:nth-child(6) .el-submenu__title {
    width: 112px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  .hardware {
    width: 100%;
    color: #3f66f5;
    height: 48.3px !important;
    border-bottom: 2px solid #3f66f5;
    text-align: center;
    // background-color: pink;
  }
  /deep/.content > ul > li:nth-child(2) .el-submenu__title {
    width: 112px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  .software {
    width: 100%;
    color: #3f66f5;
    height: 48.3px !important;
    border-bottom: 2px solid #3f66f5;
    text-align: center;
  }
  /deep/.content > ul > li:nth-child(3) .el-submenu__title {
    width: 112px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  


 
  /deep/.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #3f66f5 !important;
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal > .el-submenu:focus .el-submenu__title,.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
    border-bottom: 2px solid #3f66f5 !important;
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #3f66f5 !important;
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal .el-menu .el-menu-item.is-active,.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    // border-bottom: 2px solid #3f66f5 !important;
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
    color: #666;
  }
  /deep/.el-menu--horizontal > .el-menu-item {
    color: #666;
  }
  /deep/.el-menu--horizontal .el-menu .el-menu-item,.el-menu--horizontal .el-menu .el-submenu__title {
    color: #666;
  }
  /deep/.el-menu.el-menu--horizontal {
    border-bottom: none;
    display: flex;
    justify-content: space-between;
  }
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
    display: none;
  }
  /deep/.el-dropdown-menu__item,.el-menu-item {
    font-size: 18px;
    font-weight: 520;
    padding-top: 0.1rem;
  }
  /deep/.el-submenu__title {
    font-size: 18px;
    font-weight: 500;
    padding-top: 0.1rem;
  }
  /deep/.el-menu--popup {
    border-radius: 8px;
    min-width: 1rem;
    margin-left: 7px;
  }
  /deep/.el-submenu .el-menu-item {
    min-width: 1rem;
  }

  /deep/.el-menu--horizontal .el-menu-item:nth-child(8){
    color: #666 !important;
    border-bottom: none !important;
  }

  //悬浮小标识
  .float {
    position: fixed;
    z-index: 33;
    right: 1%;
    top: 55%;
    width: 90px;
    background-color: #fff;
    text-align: center;
    border-radius: 5px;
    padding-bottom: 10px;
    .top {
      height: 61px;
      position: relative;
      margin-bottom: 12px;
      transition: all 0.8s;
    }
    img {
      width: 45%;
      margin-top: 18px;
    }
    .chart {
      position: relative;
      .ewm {
        display: none;
        position: absolute;
        left: -206%;
        top: -30%;
      }
    }
    .chart:hover .ewm {
      display: block;
    }
    .wchart {
      position: relative;
      img {
        width: 46px;
      }
      .ewm {
        display: none;
        position: absolute;
        left: -206%;
        top: -50%;
      }
    }
    .wchart:hover .ewm {
      display: block;
    }
    .wchart:hover .ewm img {
      width: 45%;
    }

    .phone {
      position: relative;
      .dh {
        display: none;
        position: absolute;
        left: -129%;
        top: 35%;
        width: 115px;
        height: 40px;
        line-height: 40px;
        color: #777777;
        background-color: #fff;
        box-shadow: 0 2px 20px rgb(150 150 150 / 30%);
        border-radius: 2px;
      }
    }
    .phone:hover .dh {
      display: block;
    }
  }
  /deep/.el-backtop {
    position: absolute;
    top: 16px !important;
    left: 25px !important;
  }

  /deep/.el-badge__content.is-fixed {
    right: 37px;
    top: 22px;
  }
}

@media screen and (max-width: 750px) {

  .activeSub{
    display: block;
  }
  .active{
    border-bottom: 0.02rem solid #3f66f5;
    color:#3f66f5 ;
  }
  .dyColor{
    color:#3f66f5 ;
  }

  .list-item{
    padding:0.13rem 0 0.01rem 0;
    //  margin: 0 0.15rem; 
     width: 0.35rem;
  }
  .box{
    padding-top: 0.13rem;
    // width:0.05rem;
  }
  .head{
    height: 0.37rem;
    .header {
    display: flex;
    // align-items: end;
    width: 100%;
    position: fixed;
    top: 0px;
    z-index: 222;
    padding-bottom: 0.03rem;
    background-color: #fff;
    .logo {
      position: relative;
      // width: 3.3rem;
      img {
        display: block;
        width: 45px;
        margin-top: 0.21rem;
        margin-left: 0.12rem;
        margin-right: 0.02rem;
      }
    }
    .href {
      display: none;
      // width: 5rem;
      // padding-top: 0.18rem;
      // padding-left: 0.05rem;
      // // padding-bottom: 0.02rem;
      // font-size: 0.06rem;
      // a {
      //   color: #666;
      //   font-weight: 520;
      // }
      // a:hover {
      //   color: #3f66f5;
      // }
    }

    .content{
    flex: 1;
    cursor: pointer;
    display: flex;
    padding-top: 0.05rem;
    color: #666;
    .list{
      flex: 1;
      .list-top{
        position: relative;
        font-size: 0.06rem;
        font-weight: 500;
        text-align: center;
        width: 0.35rem;
        .list-sub{
          position: absolute;
          top: 0.25rem;
          left: 0px;
          background-color: #fff;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          padding: 0.05rem;
          border-radius: 0.05rem;
          text-align: left;
          min-width: 0.65rem;
          .sub-item{
            color: #666;
            height: 0.18rem;
            line-height: 0.18rem;
            font-size:0.01rem;
          }

        }

      }
    }
  }

  }
  

  }

  


  
  
 
  
  .info-title {
    padding: 0.15rem;
    text-align: center;
    font-size: 0.16rem;
    margin-top: 0.08rem;
  }
  .info {
    display: none;
  }
  .about {
    width: 100%;
    color: #3f66f5;
    height: 0.13rem !important;
    border-bottom: 2px solid #3f66f5;
    text-align: center;
  }
  /deep/.content > ul > li:nth-child(6) .el-submenu__title {
    width: 0.34rem;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  .hardware {
    width: 100%;
    color: #3f66f5;
    height: 0.13rem !important;
    border-bottom: 2px solid #3f66f5;
    text-align: center;
    // background-color: pink;
  }
  /deep/.content > ul > li:nth-child(2) .el-submenu__title {
    width: 0.34rem;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  .software {
    width: 100%;
    color: #3f66f5;
    height: 0.13rem !important;
    border-bottom: 2px solid #3f66f5;
    text-align: center;
  }
  /deep/.content > ul > li:nth-child(3) .el-submenu__title {
    width: 0.34rem;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  

  /deep/.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #3f66f5 !important;
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal > .el-submenu:focus .el-submenu__title,
  .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
    border-bottom: 2px solid #3f66f5 !important;
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #3f66f5 !important;
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal .el-menu .el-menu-item.is-active,.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    // border-bottom: 2px solid #3f66f5 !important;
    color: #3f66f5 !important;
  }
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
    color: #666;
  }
  /deep/.el-menu--horizontal > .el-menu-item {
    color: #666;
  }
  /deep/.el-menu--horizontal .el-menu .el-menu-item,.el-menu--horizontal .el-menu .el-submenu__title {
    color: #666;
  }
  /deep/.el-menu.el-menu--horizontal {
    border-bottom: none;
    display: flex;
    justify-content: start;
  }
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
    display: none;
  }
  /deep/.el-dropdown-menu__item,
  .el-menu-item {
    font-size: 0.06rem;
    padding-top: 0.1rem;
  }
  /deep/.el-submenu__title {
    font-size: 0.06rem;
    padding-top: 0.1rem;
  }
  /deep/.el-menu--popup {
    border-radius: 8px;
    min-width: 1rem;
    margin-left: 0.07rem;
  }
  /deep/.el-submenu .el-menu-item {
    min-width: 1rem;
  }
  /deep/.el-menu-item {
    padding: 0 0.05rem;
  }
  /deep/.el-menu--horizontal > .el-menu-item {
    height: 0.25rem;
    line-height: 0.35rem;
  }
  /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 0.25rem;
    line-height: 0.15rem;
  }
  /deep/.el-menu--horizontal .el-menu .el-menu-item,.el-menu--horizontal .el-menu .el-submenu__title {
    height: 0.15rem !important;
    line-height: 0.15rem !important;
    padding: 0 0.05rem !important;
    font-size: 0.06rem !important;
  }
  /deep/.el-menu--horizontal .el-menu-item:nth-child(8){
    color: #666 !important;
    border-bottom: none !important;
  }

  //悬浮小标识
  .float {
    display: none;
  }
  /deep/.el-backtop {
    position: absolute;
    top: 0.16rem !important;
    left: 0.25rem !important;
  }
}
</style>